var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('h2',[_vm._v("Unelgee1 Monitoring")]),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"red"}}):_c('div',_vm._l((_vm.schools),function(ss,ssIndex){return _c('p',{key:ssIndex},[_vm._v(" "+_vm._s(ss.name))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }